import { render, staticRenderFns } from "./ExpirationActionsDialog.vue?vue&type=template&id=59f5801f"
import script from "./ExpirationActionsDialog.vue?vue&type=script&lang=js"
export * from "./ExpirationActionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports